var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapsHomeWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:outline-maps-home-work"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.08332 2.91667H7.91666V3.75H7.08332V2.91667ZM7.08332 4.58333H7.91666V5.41667H7.08332V4.58333ZM7.08332 6.25H7.91666V7.08333H7.08332V6.25ZM0.416656 4.58333V8.75H2.91666V6.66667H3.74999V8.75H6.24999V4.58333L3.33332 2.5L0.416656 4.58333ZM5.41666 7.91667H4.58332V5.83333H2.08332V7.91667H1.24999V5L3.33332 3.54167L5.41666 5V7.91667Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.16666 1.25V2.07083L4.99999 2.66667V2.08333H8.74999V7.91667H7.08332V8.75H9.58332V1.25H4.16666Z",
    fill: "#BABABA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsHomeWork);
export default __webpack_public_path__ + "static/media/maps-home-work.79525248ac91f104a989aa5be6c0f9fb.svg";
export { ForwardRef as ReactComponent };